module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/assessment_achievements/2_1cb47e07c2f95186adad5be7df5a3801.jpg";